import { render, staticRenderFns } from "./returnGoodslistDialog.vue?vue&type=template&id=673a1ef9&scoped=true"
import script from "./returnGoodslistDialog.vue?vue&type=script&lang=js"
export * from "./returnGoodslistDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a1ef9",
  null
  
)

export default component.exports